// extracted by mini-css-extract-plugin
module.exports = {"jobContainer":"pages-user-userWorkHistory__jobContainer--321kg"};